import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

/**
 * Tab panel holds the content that is displayed when a tab is active
 * @param {*} props
 */
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Box
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </Box>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default TabPanel;
